module.exports = __webpack_public_path__ + "media/images/rh+-6f09143c085cb5c739790fa90b12e9f1.png";